import {focusable, IFocusableComponentInjectedProps} from 'focus-manager/web';
import * as React from 'react';

import Logo from './Logo';

const Tile: React.FC<IFocusableComponentInjectedProps> = ({isFocused, setFocusableElementRef}) => {
    const className = ['tile', isFocused && 'tile--focused'].filter(Boolean).join(' ');

    return (
        <a href="#" ref={setFocusableElementRef} className={className} tabIndex={-1}>
            <Logo className="tile__logo" />
        </a>
    );
};

export default focusable(Tile);
